import { defineMessages } from 'react-intl';

export default defineMessages({
    PaymentsHeader: {
        id: 'cep.components.PaymentPage.PaymentsHeader',
        defaultMessage: 'Payments'
    },
});
